import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Index from "./pages/Index.tsx";
import Terms from "./pages/Terms.tsx";
import Privacy from "./pages/Privacy.tsx";
import Cookies from "./pages/Cookies.tsx";
import Ibiza from "./pages/Ibiza.tsx";
import YachtsBrand from "./pages/YachtsBrand.tsx";
import Yachts from "./pages/Yachts.tsx";
import YachtDetail from "./pages/YachtDetail.tsx";
import Residences from "./pages/Residences.tsx";
import IbizaResidences from "./pages/IbizaResidences.tsx";
import ResidenceDetail from "./pages/ResidenceDetail.tsx";
import Drive from "./pages/Drive.tsx";
import IbizaDrive from "./pages/IbizaDrive.tsx";
import CarDetail from "./pages/CarDetail.tsx";
import Lifestyle from "./pages/Lifestyle.tsx";
import IbizaLifestyle from "./pages/IbizaLifestyle.tsx";
import IbizaNights from "./pages/IbizaNights.tsx";
import IbizaNightsVenue from "./pages/IbizaNightsVenue.tsx";
import AboutUs from "./pages/AboutUs.tsx";
import Contact from "./pages/Contact.tsx";
import Marbella from "./pages/Marbella.tsx";
import MarbellaYachts from "./pages/MarbellaYachts.tsx";
import MarbellaYachtDetail from "./pages/MarbellaYachtDetail.tsx";
import MarbellaDrive from "./pages/MarbellaDrive.tsx";
import MarbellaCarDetail from "./pages/MarbellaCarDetail.tsx";
import MarbellaResidences from "./pages/MarbellaResidences.tsx";
import MarbellaResidenceDetail from "./pages/MarbellaResidenceDetail.tsx";
import Paris from "./pages/Paris.tsx";
import Dubai from "./pages/Dubai.tsx";
import ParisLifestyle from "./pages/ParisLifestyle.tsx";
import SaintTropez from "./pages/SaintTropez.tsx";
import SaintTropezLifestyle from "./pages/SaintTropezLifestyle.tsx";
import SaintTropezResidences from "./pages/SaintTropezResidences.tsx";
import SaintTropezResidenceDetail from "./pages/SaintTropezResidenceDetail.tsx";
import MarbellaLifestyle from "./pages/MarbellaLifestyle.tsx";
import NotFound from "./pages/NotFound.tsx";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/ibiza" element={<Ibiza />} />
            <Route path="/yachts" element={<YachtsBrand />} />
            <Route path="/yachts/ibiza" element={<Yachts />} />
            <Route path="/yachts/:slug" element={<YachtDetail />} />
            <Route path="/residences" element={<Residences />} />
            <Route path="/ibiza/residences" element={<IbizaResidences />} />
            <Route path="/residences/:slug" element={<ResidenceDetail />} />
            <Route path="/drive" element={<Drive />} />
            <Route path="/drive/ibiza" element={<IbizaDrive />} />
            <Route path="/drive/ibiza/:slug" element={<CarDetail />} />
            <Route path="/lifestyle" element={<Lifestyle />} />
            <Route path="/ibiza/lifestyle" element={<IbizaLifestyle />} />
            <Route path="/ibiza/nights" element={<IbizaNights />} />
            <Route path="/ibiza/nights/:slug" element={<IbizaNightsVenue />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/marbella" element={<Marbella />} />
            <Route path="/yachts/marbella" element={<MarbellaYachts />} />
            <Route path="/yachts/marbella/:slug" element={<MarbellaYachtDetail />} />
            <Route path="/drive/marbella" element={<MarbellaDrive />} />
            <Route path="/drive/marbella/:slug" element={<MarbellaCarDetail />} />
            <Route path="/marbella/residences" element={<MarbellaResidences />} />
            <Route path="/marbella/residences/:slug" element={<MarbellaResidenceDetail />} />
            <Route path="/paris" element={<Paris />} />
            <Route path="/dubai" element={<Dubai />} />
            <Route path="/paris/lifestyle" element={<ParisLifestyle />} />
            <Route path="/saint-tropez" element={<SaintTropez />} />
            <Route path="/saint-tropez/lifestyle" element={<SaintTropezLifestyle />} />
            <Route path="/saint-tropez/residences" element={<SaintTropezResidences />} />
            <Route path="/saint-tropez/residences/:slug" element={<SaintTropezResidenceDetail />} />
            <Route path="/marbella/lifestyle" element={<MarbellaLifestyle />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
